// Viewport-width hook driving the workbench shell's field-tablet collapse
// (roadmap A1: below ~900px the menu bar becomes a single "เมนู" button and
// the left tree becomes a toggle). Uses window.innerWidth + a resize
// listener rather than matchMedia — jsdom (the test environment) has no
// matchMedia polyfill by default, and this needs zero setup in tests.
import { useEffect, useState } from "react";

export function useIsNarrow(breakpoint = 900): boolean {
  const [narrow, setNarrow] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false);
  useEffect(() => {
    function onResize() { setNarrow(window.innerWidth < breakpoint); }
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return narrow;
}
